/** Datentypen der von `BaseEntity` geerbten Eigenschaften. */

import type { BaseEntity } from '../entities';
import type { ColumnValueType } from '../fieldTypes';

/**
 * Wird an das Ende jeder Entitätstabelle gespiegelt — `typeof(T).GetProperties()`
 * liefert die geerbten Eigenschaften ebenfalls, und zwar nach den eigenen.
 */
export const baseEntityFieldTypes: Readonly<Record<keyof BaseEntity, ColumnValueType>> = {
  Id: 'integer',
  Created: 'date',
  CreatedByUserId: 'integer',
  Modified: 'date',
  ModifiedByUserId: 'integer',
  Timestamp: 'string',
};
